<span class="live-timeline">{{ currentDate }}</span>